import { getEncounterRecord, searchEncounters } from "../../../apps/api/Encounter";
import { subjectPatientRef } from "./statusLabels";

const PAGE_SIZE = 100;

export function appointmentHasLinkedEncounter(appointment, encounter) {
  return Boolean(encounter?.id || appointment?.encounterId);
}

export async function loadAppointmentEncounter(appointment, organizationRef) {
  if (appointment.encounterId) {
    const response = await getEncounterRecord({ encounterId: appointment.encounterId });
    return response?.data || null;
  }
  if (appointment.bookingContext) return null;
  const patientId = subjectPatientRef(appointment);
  if (!patientId || !organizationRef || !appointment.appointmentId) return null;

  // Launching or rescheduling can change encounter dates, assignees and status.
  // getAll includes child organizations; it does not disable pagination.
  for (let page = 1; page <= 100; page += 1) {
    const response = await searchEncounters({ orgId: organizationRef, patientId, page, pageSize: PAGE_SIZE });
    const rows = Array.isArray(response?.data) ? response.data : [];
    const match = rows.find((row) => row.appointmentId === appointment.appointmentId);
    if (match?.id) {
      const record = await getEncounterRecord({ encounterId: match.id });
      return record?.data || null;
    }
    if (rows.length < PAGE_SIZE || page * PAGE_SIZE >= response?.count?.Count) return null;
  }
  throw new Error("Could not find the linked encounter within the search limit.");
}
